"use strict";

import { c as _c } from "react/compiler-runtime";
import { useSupplierPortalAsideItems } from '@autoguru/aside-items';
import { ExpandSideNav } from '@autoguru/expand-side-nav';
import { MFE_BASE_PATH, RETAIL_LOGOUT_URL, RETAIL_URL } from '@autoguru/global-configs';
import { useSelectedGlobalSupplier } from '@autoguru/supplier-provider';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppAside = () => {
  const $ = _c(5);
  if ($[0] !== "6bc8fe7e29f5a6f8d60c54c5acd03177775862271d6cd71432bb89803f83540e") {
    for (let $i = 0; $i < 5; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "6bc8fe7e29f5a6f8d60c54c5acd03177775862271d6cd71432bb89803f83540e";
  }
  const {
    slug
  } = useSelectedGlobalSupplier();
  let t0;
  if ($[1] !== slug) {
    t0 = {
      baseUrl: MFE_BASE_PATH,
      supplierSlug: slug
    };
    $[1] = slug;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const asideItems = useSupplierPortalAsideItems(t0);
  let t1;
  if ($[3] !== asideItems) {
    t1 = /*#__PURE__*/_jsx(ExpandSideNav, {
      includeAuth: true,
      logoutRedirect: RETAIL_URL,
      logoutUrl: `${RETAIL_LOGOUT_URL}`,
      asideItems: asideItems
    });
    $[3] = asideItems;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};